import React, { memo, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core';
import { Drawer } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { partnerListIsOpenSelector } from '../../store/modules/ui/selectors';
import clsx from 'clsx';
import { useContainerDimensions } from 'global/react/hooks/useContainerDimensions';
import PartnerList from './PartnerList';


type PartnerListDrawerProps = {
	classes: any;
};

const PartnerListDrawer: React.FC<PartnerListDrawerProps> = ({ classes }) => {
	const isPartnerListDrawerVisible = useSelector(partnerListIsOpenSelector);
	const internalClasses = useStyles({ isPartnerListDrawerVisible })();
	const containerRef = useRef();
	const { width, height } = useContainerDimensions(containerRef);

	return (
		<Drawer
			ref={containerRef}
			className={clsx(classes.drawer, internalClasses.root)}
			variant="persistent"
			anchor="left"
			open={isPartnerListDrawerVisible}
			classes={{
				paper: classes.drawerPaper,
			}}
			ModalProps={{
				keepMounted: true,
			}}>
			<PartnerList width={width} height={height} />
		</Drawer>
	);
};

export default memo(PartnerListDrawer);

const useStyles = (props) =>
	makeStyles((theme) => ({
		root: {
			display: 'none',
			[theme.breakpoints.up('lg')]: {
				display: props.isPartnerListDrawerVisible ? 'block' : 'hidden',
			},
		},
	}));
